import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import {
  DELETE_CONFIRM,
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { KNPService } from 'services/KNPSerivce';
import { KNPForm } from './KNPForm';
import { KNPTable } from './KNPTable';

function KNP() {
  useDocumentTitle('КНП');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger('КНП');
  const { page, perPage, totalRows, setPagination, setTotalRows } =
    usePagination();

  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();

  const knpRecordFields = useMemo(
    () => [
      { label: 'Наименование', key: 'name' },
      { label: 'Код', key: 'code' },
    ],
    []
  );

  const fetchItems = useCallback(async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await KNPService.getKNP({ page, perPage });
      setItems(items);
      setCount(total);
      setTotalRows(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => fetchItems(), [fetchItems]);

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING, 0);

    try {
      const isDeleted = await KNPService.deleteKNP(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        await fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="knp" />

      <KNPTable
        items={items}
        loading={loading}
        current={page}
        pageSize={perPage}
        onRowClick={openDrawer}
        total={totalRows}
        onChange={setPagination}
      />

      <KNPForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchItems}
        onClose={closeForm}
      />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={knpRecordFields}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText={DELETE_CONFIRM}
        pageId="knp"
      />
    </>
  );
}

export { KNP };
